import { LOOM_URI, SLACK_INTEGRATION_URI } from 'constants/routes';

// From https://docs.microsoft.com/en-us/aspnet/mvc/overview/security/preventing-open-redirection-attacks
function isURLLocalToHost(str) {
  return (
    str[0] == '/' && (str.length == 1 || (str[1] != '/' && str[1] != '\\')) // "/" or "/foo" but not "//" or "/\"
  );
}

export default str =>
  str &&
  !str.startsWith(LOOM_URI) &&
  str !== SLACK_INTEGRATION_URI &&
  !isURLLocalToHost(str);
